import * as X from "react";
import Wr, { forwardRef as zr, useContext as Ur } from "react";
import { Image as At } from "@illa-design/image";
import { EmptyIcon as $t } from "@illa-design/icon";
import { ConfigProviderContext as kt, def as It } from "@illa-design/config-provider";
import { css as qr } from "@emotion/react";
import { globalColor as Br, illaPrefix as Gr, applyBoxStyle as Dt, deleteCssProps as Ft } from "@illa-design/theme";
var nr = { exports: {} }, me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Or;
function Mt() {
  if (Or)
    return me;
  Or = 1;
  var e = Wr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, h) {
    var d, y = {}, $ = null, k = null;
    h !== void 0 && ($ = "" + h), p.key !== void 0 && ($ = "" + p.key), p.ref !== void 0 && (k = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: $, ref: k, props: y, _owner: o.current };
  }
  return me.Fragment = n, me.jsx = f, me.jsxs = f, me;
}
var ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pr;
function jt() {
  return Pr || (Pr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Wr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, b = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = N && t[N] || t[b];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        P("error", t, u);
      }
    }
    function P(t, s, u) {
      {
        var m = S.ReactDebugCurrentFrame, R = m.getStackAddendum();
        R !== "" && (s += "%s", u = u.concat([R]));
        var A = u.map(function(_) {
          return String(_);
        });
        A.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, A);
      }
    }
    var I = !1, c = !1, V = !1, O = !1, qe = !1, Re;
    Re = Symbol.for("react.module.reference");
    function Be(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || qe || t === o || t === h || t === d || O || t === k || I || c || V || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Re || t.getModuleId !== void 0));
    }
    function Ge(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var R = s.displayName || s.name || "";
      return R !== "" ? u + "(" + R + ")" : u;
    }
    function xe(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return xe(s) + ".Consumer";
          case f:
            var u = t;
            return xe(u._context) + ".Provider";
          case p:
            return Ge(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : B(t.type) || "Memo";
          case $: {
            var R = t, A = R._payload, _ = R._init;
            try {
              return B(_(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Q = 0, we, Ce, ue, Te, fe, Oe, Pe;
    function Ne() {
    }
    Ne.__reactDisabledLog = !0;
    function Je() {
      {
        if (Q === 0) {
          we = console.log, Ce = console.info, ue = console.warn, Te = console.error, fe = console.group, Oe = console.groupCollapsed, Pe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Q++;
      }
    }
    function Ke() {
      {
        if (Q--, Q === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: we
            }),
            info: H({}, t, {
              value: Ce
            }),
            warn: H({}, t, {
              value: ue
            }),
            error: H({}, t, {
              value: Te
            }),
            group: H({}, t, {
              value: fe
            }),
            groupCollapsed: H({}, t, {
              value: Oe
            }),
            groupEnd: H({}, t, {
              value: Pe
            })
          });
        }
        Q < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = S.ReactCurrentDispatcher, de;
    function re(t, s, u) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (R) {
            var m = R.stack.trim().match(/\n( *(at )?)/);
            de = m && m[1] || "";
          }
        return `
` + de + t;
      }
    }
    var pe = !1, te;
    {
      var He = typeof WeakMap == "function" ? WeakMap : Map;
      te = new He();
    }
    function v(t, s) {
      if (!t || pe)
        return "";
      {
        var u = te.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      pe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = le.current, le.current = null, Je();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Z) {
              m = Z;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (Z) {
              m = Z;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            m = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && m && typeof Z.stack == "string") {
          for (var g = Z.stack.split(`
`), W = m.stack.split(`
`), D = g.length - 1, M = W.length - 1; D >= 1 && M >= 0 && g[D] !== W[M]; )
            M--;
          for (; D >= 1 && M >= 0; D--, M--)
            if (g[D] !== W[M]) {
              if (D !== 1 || M !== 1)
                do
                  if (D--, M--, M < 0 || g[D] !== W[M]) {
                    var q = `
` + g[D].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && te.set(t, q), q;
                  }
                while (D >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        pe = !1, le.current = A, Ke(), Error.prepareStackTrace = R;
      }
      var oe = t ? t.displayName || t.name : "", Tr = oe ? re(oe) : "";
      return typeof t == "function" && te.set(t, Tr), Tr;
    }
    function ve(t, s, u) {
      return v(t, !1);
    }
    function ne(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ne(t));
      if (typeof t == "string")
        return re(t);
      switch (t) {
        case h:
          return re("Suspense");
        case d:
          return re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return ve(t.render);
          case y:
            return ee(t.type, s, u);
          case $: {
            var m = t, R = m._payload, A = m._init;
            try {
              return ee(A(R), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var Ae = Object.prototype.hasOwnProperty, hr = {}, mr = S.ReactDebugCurrentFrame;
    function $e(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        mr.setExtraStackFrame(u);
      } else
        mr.setExtraStackFrame(null);
    }
    function lt(t, s, u, m, R) {
      {
        var A = Function.call.bind(Ae);
        for (var _ in t)
          if (A(t, _)) {
            var g = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              g = t[_](s, _, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              g = D;
            }
            g && !(g instanceof Error) && ($e(R), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, _, typeof g), $e(null)), g instanceof Error && !(g.message in hr) && (hr[g.message] = !0, $e(R), E("Failed %s type: %s", u, g.message), $e(null));
          }
      }
    }
    var dt = Array.isArray;
    function Ze(t) {
      return dt(t);
    }
    function pt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function vt(t) {
      try {
        return yr(t), !1;
      } catch {
        return !0;
      }
    }
    function yr(t) {
      return "" + t;
    }
    function Er(t) {
      if (vt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(t)), yr(t);
    }
    var he = S.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, gr, br, Xe;
    Xe = {};
    function mt(t) {
      if (Ae.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function yt(t) {
      if (Ae.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Et(t, s) {
      if (typeof t.ref == "string" && he.current && s && he.current.stateNode !== s) {
        var u = B(he.current.type);
        Xe[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(he.current.type), t.ref), Xe[u] = !0);
      }
    }
    function gt(t, s) {
      {
        var u = function() {
          gr || (gr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var u = function() {
          br || (br = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var _t = function(t, s, u, m, R, A, _) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: _,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function St(t, s, u, m, R) {
      {
        var A, _ = {}, g = null, W = null;
        u !== void 0 && (Er(u), g = "" + u), yt(s) && (Er(s.key), g = "" + s.key), mt(s) && (W = s.ref, Et(s, R));
        for (A in s)
          Ae.call(s, A) && !ht.hasOwnProperty(A) && (_[A] = s[A]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (A in D)
            _[A] === void 0 && (_[A] = D[A]);
        }
        if (g || W) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          g && gt(_, M), W && bt(_, M);
        }
        return _t(t, g, W, R, m, he.current, _);
      }
    }
    var Qe = S.ReactCurrentOwner, _r = S.ReactDebugCurrentFrame;
    function ae(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        _r.setExtraStackFrame(u);
      } else
        _r.setExtraStackFrame(null);
    }
    var er;
    er = !1;
    function rr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Sr() {
      {
        if (Qe.current) {
          var t = B(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Rt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Rr = {};
    function xt(t) {
      {
        var s = Sr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function xr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = xt(s);
        if (Rr[u])
          return;
        Rr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== Qe.current && (m = " It was passed a child from " + B(t._owner.type) + "."), ae(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ae(null);
      }
    }
    function wr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (Ze(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            rr(m) && xr(m, s);
          }
        else if (rr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var A = R.call(t), _; !(_ = A.next()).done; )
              rr(_.value) && xr(_.value, s);
        }
      }
    }
    function wt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = B(s);
          lt(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !er) {
          er = !0;
          var R = B(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ct(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            ae(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ae(null);
            break;
          }
        }
        t.ref !== null && (ae(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Cr(t, s, u, m, R, A) {
      {
        var _ = Be(t);
        if (!_) {
          var g = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Rt(R);
          W ? g += W : g += Sr();
          var D;
          t === null ? D = "null" : Ze(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (B(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, g);
        }
        var M = St(t, s, u, R, A);
        if (M == null)
          return M;
        if (_) {
          var q = s.children;
          if (q !== void 0)
            if (m)
              if (Ze(q)) {
                for (var oe = 0; oe < q.length; oe++)
                  wr(q[oe], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wr(q, t);
        }
        return t === a ? Ct(M) : wt(M), M;
      }
    }
    function Tt(t, s, u) {
      return Cr(t, s, u, !0);
    }
    function Ot(t, s, u) {
      return Cr(t, s, u, !1);
    }
    var Pt = Ot, Nt = Tt;
    ye.Fragment = a, ye.jsx = Pt, ye.jsxs = Nt;
  }()), ye;
}
process.env.NODE_ENV === "production" ? nr.exports = Mt() : nr.exports = jt();
var je = nr.exports;
function Vt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Yt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Lt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Yt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = Vt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", Ve = "-moz-", x = "-webkit-", ur = "comm", fr = "rule", lr = "decl", Wt = "@import", Jr = "@keyframes", zt = "@layer", Ut = Math.abs, Le = String.fromCharCode, qt = Object.assign;
function Bt(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function Kr(e) {
  return e.trim();
}
function Gt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function ar(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function ge(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function dr(e) {
  return e.length;
}
function ke(e, r) {
  return r.push(e), e;
}
function Jt(e, r) {
  return e.map(r).join("");
}
var We = 1, se = 1, Hr = 0, z = 0, j = 0, ce = "";
function ze(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: We, column: se, length: f, return: "" };
}
function Ee(e, r) {
  return qt(ze("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Kt() {
  return j;
}
function Ht() {
  return j = z > 0 ? Y(ce, --z) : 0, se--, j === 10 && (se = 1, We--), j;
}
function U() {
  return j = z < Hr ? Y(ce, z++) : 0, se++, j === 10 && (se = 1, We++), j;
}
function K() {
  return Y(ce, z);
}
function De() {
  return z;
}
function Se(e, r) {
  return ge(ce, e, r);
}
function be(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zr(e) {
  return We = se = 1, Hr = J(ce = e), z = 0, [];
}
function Xr(e) {
  return ce = "", e;
}
function Fe(e) {
  return Kr(Se(z - 1, or(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Zt(e) {
  for (; (j = K()) && j < 33; )
    U();
  return be(e) > 2 || be(j) > 3 ? "" : " ";
}
function Xt(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Se(e, De() + (r < 6 && K() == 32 && U() == 32));
}
function or(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && or(j);
        break;
      case 40:
        e === 41 && or(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function Qt(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && K() === 47)
      break;
  return "/*" + Se(r, z - 1) + "*" + Le(e === 47 ? e : U());
}
function en(e) {
  for (; !be(K()); )
    U();
  return Se(e, z);
}
function rn(e) {
  return Xr(Me("", null, null, null, [""], e = Zr(e), 0, [0], e));
}
function Me(e, r, n, a, o, i, f, l, p) {
  for (var h = 0, d = 0, y = f, $ = 0, k = 0, N = 0, b = 1, F = 1, S = 1, E = 0, P = "", I = o, c = i, V = a, O = P; F; )
    switch (N = E, E = U()) {
      case 40:
        if (N != 108 && Y(O, y - 1) == 58) {
          ar(O += w(Fe(E), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Fe(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Zt(N);
        break;
      case 92:
        O += Xt(De() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            ke(tn(Qt(U(), De()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * b:
        l[h++] = J(O) * S;
      case 125 * b:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            F = 0;
          case 59 + d:
            S == -1 && (O = w(O, /\f/g, "")), k > 0 && J(O) - y && ke(k > 32 ? Ar(O + ";", a, n, y - 1) : Ar(w(O, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (ke(V = Nr(O, r, n, h, d, o, l, P, I = [], c = [], y), i), E === 123)
              if (d === 0)
                Me(O, r, V, V, I, i, y, l, c);
              else
                switch ($ === 99 && Y(O, 3) === 110 ? 100 : $) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Me(e, V, V, a && ke(Nr(e, V, V, 0, 0, o, l, P, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    Me(O, V, V, V, [""], c, 0, l, c);
                }
        }
        h = d = k = 0, b = S = 1, P = O = "", y = f;
        break;
      case 58:
        y = 1 + J(O), k = N;
      default:
        if (b < 1) {
          if (E == 123)
            --b;
          else if (E == 125 && b++ == 0 && Ht() == 125)
            continue;
        }
        switch (O += Le(E), E * b) {
          case 38:
            S = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            l[h++] = (J(O) - 1) * S, S = 1;
            break;
          case 64:
            K() === 45 && (O += Fe(U())), $ = K(), d = y = J(P = O += en(De())), E++;
            break;
          case 45:
            N === 45 && J(O) == 2 && (b = 0);
        }
    }
  return i;
}
function Nr(e, r, n, a, o, i, f, l, p, h, d) {
  for (var y = o - 1, $ = o === 0 ? i : [""], k = dr($), N = 0, b = 0, F = 0; N < a; ++N)
    for (var S = 0, E = ge(e, y + 1, y = Ut(b = f[N])), P = e; S < k; ++S)
      (P = Kr(b > 0 ? $[S] + " " + E : w(E, /&\f/g, $[S]))) && (p[F++] = P);
  return ze(e, r, n, o === 0 ? fr : l, p, h, d);
}
function tn(e, r, n) {
  return ze(e, r, n, ur, Le(Kt()), ge(e, 2, -2), 0);
}
function Ar(e, r, n, a) {
  return ze(e, r, n, lr, ge(e, 0, a), ge(e, a + 1, -1), a);
}
function ie(e, r) {
  for (var n = "", a = dr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function nn(e, r, n, a) {
  switch (e.type) {
    case zt:
      if (e.children.length)
        break;
    case Wt:
    case lr:
      return e.return = e.return || e.value;
    case ur:
      return "";
    case Jr:
      return e.return = e.value + "{" + ie(e.children, a) + "}";
    case fr:
      e.value = e.props.join(",");
  }
  return J(n = ie(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function an(e) {
  var r = dr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function on(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function sn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var cn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = K(), o === 38 && i === 12 && (n[a] = 1), !be(i); )
    U();
  return Se(r, z);
}, un = function(r, n) {
  var a = -1, o = 44;
  do
    switch (be(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += cn(z - 1, n, a);
        break;
      case 2:
        r[a] += Fe(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Le(o);
    }
  while (o = U());
  return r;
}, fn = function(r, n) {
  return Xr(un(Zr(r), n));
}, $r = /* @__PURE__ */ new WeakMap(), ln = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !$r.get(a)) && !o) {
      $r.set(r, !0);
      for (var i = [], f = fn(n, i), l = a.props, p = 0, h = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, h++)
          r.props[h] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, dn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, pn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", vn = function(r) {
  return r.type === "comm" && r.children.indexOf(pn) > -1;
}, hn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var h = l[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (vn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Qr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, mn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Qr(n[a]))
      return !0;
  return !1;
}, kr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, yn = function(r, n, a) {
  Qr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), kr(r)) : mn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), kr(r)));
};
function et(e, r) {
  switch (Bt(e, r)) {
    case 5103:
      return x + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return x + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return x + e + Ve + e + L + e + e;
    case 6828:
    case 4268:
      return x + e + L + e + e;
    case 6165:
      return x + e + L + "flex-" + e + e;
    case 5187:
      return x + e + w(e, /(\w+).+(:[^]+)/, x + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return x + e + L + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return x + e + L + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return x + e + L + w(e, "shrink", "negative") + e;
    case 5292:
      return x + e + L + w(e, "basis", "preferred-size") + e;
    case 6060:
      return x + "box-" + w(e, "-grow", "") + x + e + L + w(e, "grow", "positive") + e;
    case 4554:
      return x + w(e, /([^-])(transform)/g, "$1" + x + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, x + "$1"), /(image-set)/, x + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, x + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, x + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + x + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, x + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + x + "$2-$3$1" + Ve + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ar(e, "stretch") ? et(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, J(e) - 3 - (~ar(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + x) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + x + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + x + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return x + e + L + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return x + e + L + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return x + e + L + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return x + e + L + e + e;
  }
  return e;
}
var En = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case lr:
        r.return = et(r.value, r.length);
        break;
      case Jr:
        return ie([Ee(r, {
          value: w(r.value, "@", "@" + x)
        })], o);
      case fr:
        if (r.length)
          return Jt(r.props, function(i) {
            switch (Gt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ie([Ee(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Ve + "$1")]
                })], o);
              case "::placeholder":
                return ie([Ee(r, {
                  props: [w(i, /:(plac\w+)/, ":" + x + "input-$1")]
                }), Ee(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Ve + "$1")]
                }), Ee(r, {
                  props: [w(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, gn = [En], bn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var F = b.getAttribute("data-emotion");
      F.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || gn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var F = b.getAttribute("data-emotion").split(" "), S = 1; S < F.length; S++)
        i[F[S]] = !0;
      l.push(b);
    }
  );
  var p, h = [ln, dn];
  process.env.NODE_ENV !== "production" && h.push(hn({
    get compat() {
      return N.compat;
    }
  }), yn);
  {
    var d, y = [nn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== ur && d.insert(b.value + "{}"));
    } : on(function(b) {
      d.insert(b);
    })], $ = an(h.concat(o, y)), k = function(F) {
      return ie(rn(F), $);
    };
    p = function(F, S, E, P) {
      d = E, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + S.map);
        }
      }), k(F ? F + "{" + S.styles + "}" : S.styles), P && (N.inserted[S.name] = !0);
    };
  }
  var N = {
    key: n,
    sheet: new Lt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return N.sheet.hydrate(l), N;
}, ir = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function _n() {
  if (Ir)
    return C;
  Ir = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function P(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case N:
                case k:
                case f:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function I(c) {
    return P(c) === h;
  }
  return C.AsyncMode = p, C.ConcurrentMode = h, C.ContextConsumer = l, C.ContextProvider = f, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = N, C.Memo = k, C.Portal = n, C.Profiler = i, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(c) {
    return I(c) || P(c) === p;
  }, C.isConcurrentMode = I, C.isContextConsumer = function(c) {
    return P(c) === l;
  }, C.isContextProvider = function(c) {
    return P(c) === f;
  }, C.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, C.isForwardRef = function(c) {
    return P(c) === d;
  }, C.isFragment = function(c) {
    return P(c) === a;
  }, C.isLazy = function(c) {
    return P(c) === N;
  }, C.isMemo = function(c) {
    return P(c) === k;
  }, C.isPortal = function(c) {
    return P(c) === n;
  }, C.isProfiler = function(c) {
    return P(c) === i;
  }, C.isStrictMode = function(c) {
    return P(c) === o;
  }, C.isSuspense = function(c) {
    return P(c) === y;
  }, C.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === $ || typeof c == "object" && c !== null && (c.$$typeof === N || c.$$typeof === k || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === F || c.$$typeof === S || c.$$typeof === E || c.$$typeof === b);
  }, C.typeOf = P, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Sn() {
  return Dr || (Dr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function P(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === $ || typeof v == "object" && v !== null && (v.$$typeof === N || v.$$typeof === k || v.$$typeof === f || v.$$typeof === l || v.$$typeof === d || v.$$typeof === F || v.$$typeof === S || v.$$typeof === E || v.$$typeof === b);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var ve = v.$$typeof;
        switch (ve) {
          case r:
            var ne = v.type;
            switch (ne) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ne;
              default:
                var ee = ne && ne.$$typeof;
                switch (ee) {
                  case l:
                  case d:
                  case N:
                  case k:
                  case f:
                    return ee;
                  default:
                    return ve;
                }
            }
          case n:
            return ve;
        }
      }
    }
    var c = p, V = h, O = l, qe = f, Re = r, Be = d, Ge = a, xe = N, B = k, H = n, Q = i, we = o, Ce = y, ue = !1;
    function Te(v) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), fe(v) || I(v) === p;
    }
    function fe(v) {
      return I(v) === h;
    }
    function Oe(v) {
      return I(v) === l;
    }
    function Pe(v) {
      return I(v) === f;
    }
    function Ne(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Je(v) {
      return I(v) === d;
    }
    function Ke(v) {
      return I(v) === a;
    }
    function le(v) {
      return I(v) === N;
    }
    function de(v) {
      return I(v) === k;
    }
    function re(v) {
      return I(v) === n;
    }
    function pe(v) {
      return I(v) === i;
    }
    function te(v) {
      return I(v) === o;
    }
    function He(v) {
      return I(v) === y;
    }
    T.AsyncMode = c, T.ConcurrentMode = V, T.ContextConsumer = O, T.ContextProvider = qe, T.Element = Re, T.ForwardRef = Be, T.Fragment = Ge, T.Lazy = xe, T.Memo = B, T.Portal = H, T.Profiler = Q, T.StrictMode = we, T.Suspense = Ce, T.isAsyncMode = Te, T.isConcurrentMode = fe, T.isContextConsumer = Oe, T.isContextProvider = Pe, T.isElement = Ne, T.isForwardRef = Je, T.isFragment = Ke, T.isLazy = le, T.isMemo = de, T.isPortal = re, T.isProfiler = pe, T.isStrictMode = te, T.isSuspense = He, T.isValidElementType = P, T.typeOf = I;
  }()), T;
}
process.env.NODE_ENV === "production" ? ir.exports = _n() : ir.exports = Sn();
var Rn = ir.exports, rt = Rn, xn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, tt = {};
tt[rt.ForwardRef] = xn;
tt[rt.Memo] = wn;
var Cn = !0;
function Tn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var nt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Cn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, On = function(r, n, a) {
  nt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Pn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Nn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Fr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, An = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", $n = /[A-Z]|^ms/g, at = /_EMO_([^_]+?)_([^]*?)_EMO_/g, pr = function(r) {
  return r.charCodeAt(1) === 45;
}, Mr = function(r) {
  return r != null && typeof r != "boolean";
}, tr = /* @__PURE__ */ sn(function(e) {
  return pr(e) ? e : e.replace($n, "-$&").toLowerCase();
}), Ye = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(at, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return Nn[r] !== 1 && !pr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var kn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, In = ["normal", "none", "initial", "inherit", "unset"], Dn = Ye, Fn = /^-ms-/, Mn = /-(.)/g, jr = {};
  Ye = function(r, n) {
    if (r === "content" && (typeof n != "string" || In.indexOf(n) === -1 && !kn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Dn(r, n);
    return a !== "" && !pr(r) && r.indexOf("-") !== -1 && jr[r] === void 0 && (jr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Fn, "ms-").replace(Mn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ot = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function _e(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ot);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return jn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, f = n(e);
        return G = i, _e(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(at, function(d, y, $) {
          var k = "animation" + l.length;
          return l.push("const " + k + " = keyframes`" + $.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + k + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function jn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += _e(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Mr(f) && (a += tr(i) + ":" + Ye(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ot);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Mr(f[l]) && (a += tr(i) + ":" + Ye(i, f[l]) + ";");
        else {
          var p = _e(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += tr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(An), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Vr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, it;
process.env.NODE_ENV !== "production" && (it = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Yr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += _e(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Fr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += _e(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(Fr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(it, function($) {
    return p = $, "";
  })), Vr.lastIndex = 0;
  for (var h = "", d; (d = Vr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = Pn(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, Vn = function(r) {
  return r();
}, Yn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Ln = Yn || Vn, Ue = {}.hasOwnProperty, vr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ bn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (vr.displayName = "EmotionCacheContext");
vr.Provider;
var Wn = function(r) {
  return /* @__PURE__ */ zr(function(n, a) {
    var o = Ur(vr);
    return r(n, o, a);
  });
}, st = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (st.displayName = "EmotionThemeContext");
var Lr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, zn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Lr(n[1]);
}, Un = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), qn = function(r) {
  return r.replace(/\$/g, "-");
}, Bn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = zn(n[a]);
      if (o) {
        if (Un.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return qn(o);
      }
    }
}, sr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", cr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ct = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ue.call(n, o) && (a[o] = n[o]);
  if (a[sr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Bn(new Error().stack);
    i && (a[cr] = i);
  }
  return a;
}, Gn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return nt(n, a, o), Ln(function() {
    return On(n, a, o);
  }), null;
}, ut = /* @__PURE__ */ Wn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[sr], i = [a], f = "";
  typeof e.className == "string" ? f = Tn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = Yr(i, void 0, X.useContext(st));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[cr];
    p && (l = Yr([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var h = {};
  for (var d in e)
    Ue.call(e, d) && d !== "css" && d !== sr && (process.env.NODE_ENV === "production" || d !== cr) && (h[d] = e[d]);
  return h.ref = n, h.className = f, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Gn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ut.displayName = "EmotionCssPropInternal");
var ft = ut;
function Ie(e, r, n) {
  return Ue.call(r, "css") ? je.jsx(ft, ct(e, r), n) : je.jsx(e, r, n);
}
function Jn(e, r, n) {
  return Ue.call(r, "css") ? je.jsxs(ft, ct(e, r), n) : je.jsxs(e, r, n);
}
function Kn(e) {
  return qr`
    padding: ${e} 0;
    vertical-align: middle;
    text-align: center;
  `;
}
function Hn(e) {
  return qr`
    margin-top: ${e}px;
    color: ${Br(`--${Gr}-grayBlue-04`)};
    font-size: 14px;
  `;
}
const Zn = zr((e, r) => {
  var d;
  const n = Ur(kt), a = ((d = n == null ? void 0 : n.locale) == null ? void 0 : d.empty) ?? It.empty, { icon: o = Ie($t, { size: "48px", color: Br(`--${Gr}-grayBlue-04`) }), imgSrc: i, divideSize: f = "16px", paddingVertical: l = "23px", description: p = a.noData, ...h } = e;
  return Jn("div", { ref: r, css: [Kn(l), Dt(e)], ...Ft(h), children: [Ie("div", { children: i ? Ie(At, { src: i, objectFit: "contain", width: "48px", height: "48px" }) : o }), Ie("div", { css: Hn(f), children: p })] });
});
Zn.displayName = "Empty";
export {
  Zn as Empty
};
//# sourceMappingURL=index.js.map
